import { configureStore } from "@reduxjs/toolkit";
import {
    useDispatch as useReduxDispatch,
    useSelector as useReduxSelector,
} from "react-redux";
import { ENABLE_REDUX_DEV_TOOLS } from "src/constants";
import rootReducer from "./rootReducer";

const largeAuditPaths = [
  "audit.audits",
  "audit.summons",
  "audit.currentAuditItems",
  "audit.auditStats",
];

const store = configureStore({
  reducer: rootReducer,
  devTools: ENABLE_REDUX_DEV_TOOLS,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: {
        warnAfter: 128,
        ignoredPaths: largeAuditPaths,
        ignoredActionPaths: [
          "payload.audits",
          "payload.summons",
          "payload.currentAuditItems",
          "payload.auditStats",
        ],
      },
      serializableCheck: {
        warnAfter: 128,
        ignoredPaths: largeAuditPaths,
        ignoredActionPaths: [
          "payload.audits",
          "payload.summons",
          "payload.currentAuditItems",
          "payload.auditStats",
        ],
      },
    }),
});

export const useSelector = useReduxSelector;

export const useDispatch = () => useReduxDispatch();

export default store;
